import { render, staticRenderFns } from "./photoCommander.vue?vue&type=template&id=fb10d168&scoped=true"
import script from "./photoCommander.vue?vue&type=script&lang=js"
export * from "./photoCommander.vue?vue&type=script&lang=js"
import style0 from "./photoCommander.vue?vue&type=style&index=0&id=fb10d168&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb10d168",
  null
  
)

export default component.exports